import { useEffect, useRef } from "react";

const SRC = "https://cdn.trustindex.io/loader-cert.js?7306bbd15a737739b076b2f55e6";

export const TrustBadge = () => {
  const ref = useRef(null);
  useEffect(() => {
    const box = ref.current;
    if (!box || box.childElementCount) return;
    const s = document.createElement("script");
    s.src = SRC;
    s.async = true;
    s.defer = true;
    box.appendChild(s);
    return () => { box.innerHTML = ""; document.querySelectorAll(".ti-widget.ti-certificate").forEach((n) => n.remove()); };
  }, []);
  return <div ref={ref} className="lp-foot-trust" data-testid="footer-trustindex-badge" />;
};
